<template>
  <div v-if="showFooter" class="lb-portal" data-test-logo-footer-outer-wrapper>
    <footer>
      <nav class="container">
        <div class="row">
          <div class="small-12 medium-9 large-6 columns">
            <p
              data-test-logo-footer-title-primary
              class="footer-header-underlined large-10"
              v-html="logoFooterViewModel.titlePrimary"
            />
            <div class="row small-up-1 medium-up-3">
              <div class="columns">
                <logo-footer-image :model="logoFooterViewModel.lbLogoSectionElement" />
              </div>

              <div class="columns">
                <logo-footer-image :model="logoFooterViewModel.bautaLogoSectionElement" />
              </div>

              <div class="columns">
                <logo-footer-image :model="logoFooterViewModel.runaLogoSectionElement" />
              </div>
            </div>
          </div>
          <div class="small-12 medium-3 show-for-medium-only columns" />
          <div class="small-12 medium-5 large-3 columns">
            <p
              data-test-logo-footer-title-secondary
              class="footer-header-underlined"
              v-html="logoFooterViewModel.titleSecondary"
            />

            <div class="row">
              <div class="columns">
                <logo-footer-image
                  :model="logoFooterViewModel.lbPFALogoSectionElement"
                  class="pfa"
                />
              </div>
            </div>
          </div>
          <div class="small-12 large-2 large-offset-1 hide-for-medium-only columns" />
        </div>
      </nav>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import axios from 'axios';
import LogoFooterViewModel from './interfaces/LogoFooterViewModel';
import Utility from '@/common/UtilityFunctions.js';
import LogoFooterImage from './LogoFooterImage.vue';
import LogoFooterApiResponseModel from './interfaces/LogoFooterApiResponseModel';

export default defineComponent({
  name: 'LogoFooter',
  components: {
    LogoFooterImage
  },
  props: {
    datasource: {
      type: [String, null] as PropType<String | null>,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      logoFooterViewModel: {
        lbLogoSectionElement: null,
        bautaLogoSectionElement: null,
        runaLogoSectionElement: null,
        lbPFALogoSectionElement: null,
        titlePrimary: '',
        titleSecondary: ''
      } as LogoFooterViewModel
    };
  },
  computed: {
    showFooter(): boolean {
      return this.datasource !== '' && this.datasource !== null;
    }
  },
  mounted(): void {
    if (this.datasource === null) {
      return;
    }

    axios
      .get(Utility.constants().API.logofooter + this.datasource)
      .then((response: LogoFooterApiResponseModel) => {
        this.logoFooterViewModel = response.data;
      })
      .catch((error: string) => {
        Utility.logError(error, this);
      });
  }
});
</script>
